import { Select, Flex } from 'antd';
import { useGetAllNodeTypes } from 'api/node/use-get-node-types';
import { CustomBadge } from 'components/analytics/styles';
import { Text } from 'components/typography';
import { useAppForms } from 'context/app-forms';
import { APP_FORM_ACTIONS } from 'context/app-forms/reducer';
import { PATHS } from 'helpers/constants';
import React, { useMemo } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export const NodeTypes: React.FC = () => {
  const { handleAction, nodeTypeId, form } = useAppForms();

  const { id } = useParams();

  const { data, isLoading } = useGetAllNodeTypes();
  const navigate = useNavigate();

  const onSelect = (nodeTypeId: string) => {
    handleAction({
      type: APP_FORM_ACTIONS.SELECT_NODE_TYPE,
      payload: nodeTypeId,
    });
    // when form id exist and change navigate create page
    if (form.id) {
      navigate(PATHS.APP_FORM_CREATE.replace(':id', form?.project_id));
    }
  };

  const onClear = () => {
    handleAction({
      type: APP_FORM_ACTIONS.SELECT_NODE_TYPE,
      payload: '',
    });
    navigate(PATHS.APP_FORM_CREATE.replace(':id', id || ''));
  };

  const options = useMemo(
    () =>
      data?.map((type) => ({
        label: (
          <Flex gap={16}>
            <CustomBadge color={type.color} />
            {type.name}
          </Flex>
        ),
        value: type.id,
      })) || [],
    [data]
  );

  return (
    <>
      <Text style={{ fontSize: 18 }}>Node Types</Text>
      <Select
        style={{ width: '100%' }}
        placeholder="Select Node Type"
        value={nodeTypeId || undefined}
        onSelect={onSelect}
        options={options}
        onClear={onClear}
        allowClear
        loading={isLoading}
      />
    </>
  );
};
